// Step 2: Pick a roof preset. All 16 ROOF_TYPES are shown; selecting one
// seeds an initial set of RoofSection objects in the parent. The user is
// free to add/remove/edit sections afterwards in Step 3.
import React from "react";
import { ROOF_TYPES, ROOF_CATEGORIES } from "../../lib/roofTypes";

export default function PresetPicker({ value, category, onPick, onCategoryChange, onSkip }) {
  return (
    <div className="card-elev p-5" data-testid="step-roof">
      <div className="overline">Step 2</div>
      <h3 className="font-display text-2xl font-bold mt-1">Pick a starting preset</h3>
      <p className="text-sm text-slate-500 mt-1">
        Each preset seeds one or more sections. After this you can add, remove and edit unlimited sections to model any roof geometry.
      </p>

      <label className="block mt-4 max-w-xs">
        <span className="overline">Category</span>
        <select
          className="rqp mt-1.5"
          value={category}
          onChange={(e) => onCategoryChange(e.target.value)}
          data-testid="quote-roof-category"
        >
          {ROOF_CATEGORIES.map((c) => (
            <option key={c.id} value={c.id}>{c.label}</option>
          ))}
        </select>
      </label>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 mt-5">
        {ROOF_TYPES.map((t) => {
          const Svg = t.Svg;
          const selected = value === t.id;
          return (
            <button
              key={t.id}
              type="button"
              onClick={() => onPick(t.id, t.category)}
              className={`roof-card ${selected ? "selected" : ""}`}
              data-testid={`builder-roof-${t.id}`}
            >
              <div className="aspect-[4/3] bg-white border border-slate-200 rounded-sm flex items-center justify-center p-1 overflow-hidden">
                <Svg s="#1E40AF" a="#D94A31" />
              </div>
              <div className="font-display font-semibold text-xs mt-2">{t.name}</div>
              <div className="text-[10px] uppercase tracking-wider text-slate-500 mt-0.5">
                Complexity {t.complexity}/4
              </div>
            </button>
          );
        })}
      </div>

      <button
        type="button"
        onClick={onSkip}
        className="mt-5 text-xs uppercase tracking-wider font-semibold text-slate-500 hover:text-[var(--rqp-orange)]"
        data-testid="preset-skip"
      >
        Or start blank →
      </button>
    </div>
  );
}
